import * as M from "moment";
import { IWaterSupplyDefect } from "../data/coldWaterSupplyForm/types";
import Constants from "../../../constants/Common";

export const initialValuesColdWaterSupply: IWaterSupplyDefect = {
  mediaCoverage: false,
  mediaComment: null,
  addressGuid: null,
  incidentStatusId: null,
  objectTypeId: null,
  classifierTypeId: null,
  objectId: null,
  objectShortName: "",
  statusComment: "",
  districtId: null,
  addressText: null,
  dateTimeDisable: null,
  dateTimePlanned: null,
  dateTimeEnable: null,
  timeDisable: "",
  gasPlannedTime: "",
  timeEnable: "",
  disconnectedSubscribers: null,
  responsible: null,
  responsiblePhone: null,
  comment: "",
  eventTypeId: null,
  gridTypeId: 2,
  overBuildings: null,
  livingBuildings: null,
  hospitalBuildings: null,
  childrenBuildings: null,
  buildings: null,
  typeGasketId: null,
  diameter: null,
  discharge: false,
  defNatureId: null,
  standartTime: null,
  addressNote: "",
  activityTypeId: null,
  complaintCodeId: null,
  workProgressId: null,
  workStatusId: null,
  externalSystemId: 1,
  externalId: null,
  repairCategoryId: null,
  files: [],
  organizationId: null,
  addressAreaId: null,

  mkaDecisionStatusId: null,
  fullOfMkdCount: null,
  partialOfMkdCount: null,
  connectedOfMkdCount: null,
  shouldBeSendToMka: false,

  municipalityText: "",
  mkaUtilitiesSectorId: null,
  incidentDescription: null,
  parentId: null,
  mkaTechonologicalProcessStageId: null,
  mkaObjectKindId: null,
  mkaObjectType: null,
  mkaObjectName: null,
  mkaIncidentTypeId: null,
  deadCount: null,
  affectedCount: null,
  weather: null,
  fullFact: false,
  fullListOfLocation: null,
  fullListOfObjects: null,
  fullOfSocialObjectsCount: null,
  fullListOfMkd: [],
  fullOfMkdPplCount: null,
  fullOfPrivateHousesCount: null,
  fullOfPrivateHousesPplCount: null,
  fullListOfObjectsOther: null,
  partialFact: false,
  partialListOfLocation: null,
  partialListOfObjects: null,
  partialOfSocialObjectsCount: null,
  partialListOfMkd: [],
  partialOfMkdPplCount: null,
  partialOfPrivateHousesCount: null,
  partialOfPrivateHousesPplCount: null,
  partialListOfObjectsOther: null,
  connectedFact: false,
  connectedListOfCommunalServices: null,
  connectedListOfLocation: null,
  connectedListOfObjects: null,
  connectedOfSocialObjectsCount: null,
  connectedListOfMkd: [],
  connectedOfMkdPplCount: null,
  connectedOfPrivateHousesCount: null,
  connectedOfPrivateHousesPplCount: null,
  connectedListOfObjectsOther: null,
  objectOwnerName: null,
  operatingOrganizationName: null,
  planResponsibles: null,
  additionalInformation: null,
  operationalInformationSource: null,
};
